"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAsteriskPlugin = void 0;
var addAsteriskPlugin_1 = __importDefault(require("./addAsteriskPlugin"));
exports.addAsteriskPlugin = addAsteriskPlugin_1.default;
